require('../../modules/es.array.flat-map');
require('../../modules/es.array.unscopables.flat-map');

module.exports = require('../../internals/entry-unbind')('Array', 'flatMap');
